import React from 'react';
import styled from '@emotion/styled';
import { themeGet } from 'styled-system';

import type { TextDecorationProps } from '../../theme/system-utilities';
import { textDecoration } from '../../theme/system-utilities';
import { LinkRegularLR2, LinkRegularLR3 } from '../Typography';

interface CounterProps {
  count?: number;
  isUnderlined: boolean;
  isSmall: boolean;
}

const Count = styled.span<TextDecorationProps>`
  ${textDecoration};
  text-decoration-thickness: 0.5px;
  text-underline-offset: ${themeGet('space.sp_2')}px;
`;

const Counter = ({ count, isUnderlined, isSmall }: CounterProps) => {
  if (!count) {
    return null;
  }

  const Container = isSmall ? LinkRegularLR3 : LinkRegularLR2;

  return (
    <Container
      data-testid="rating-counter"
      color="sys.neutral.text.default"
      {...(isSmall ? { ml: 'sp_0' } : {})}
    >
      (<Count textDecoration={isUnderlined ? 'underline' : 'none'}>{count}</Count>)
    </Container>
  );
};

export default Counter;
